import { render, staticRenderFns } from "./OneClickBuy.vue?vue&type=template&id=542aa90e&"
import script from "./OneClickBuy.vue?vue&type=script&lang=js&"
export * from "./OneClickBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports